import { makeStyles } from "@material-ui/core";

export default makeStyles((theme) => ({
  stepperBlock: {
    background: "transparent",
    padding: theme.spacing(2.5),
  },
  horizontalLabel: {
    fontWeight: 500,
  },
  verticalLabel: {
    fontSize: 21,
    lineHeight: `${theme.spacing(1.5)}px`,
    fontWeight: 400,
  },
  stepperImageContainer: (small = false) => ({
    width: small ? theme.spacing(3) : theme.spacing(5),
    height: small ? theme.spacing(3) : theme.spacing(5),
    borderRadius: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }),
  contrast: {
    color: theme.palette.contrastText.main,
  },
}));
